(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-quantity-discounts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-discounts')) {
    customElements.define(
      'quantity-discounts',
      class QuantityDiscounts extends HTMLElement {
        connectedCallback() {
          this.buttons = Array.from(this.querySelectorAll('[data-quantity]'));
          this.productInfo = this.closest('product-info, [data-quantity-discounts-host]');
          this.quantityInput = this.productInfo?.querySelector('form[is="product-form"] .quantity__input');
          this.priceElement = this.productInfo?.querySelector(`#price-${this.dataset.sectionId}`);
          this.nextTierElement = this.productInfo?.querySelector(`#QuantityDiscountNext-${this.dataset.sectionId}`);
          this.customPriceInput = this.querySelector('[data-custom-price-input]');
          this.qtyDiscountInput = this.querySelector('[data-qty-discount-input]');
          this.dismissButton = this.querySelector('[data-qd-dismiss]');
          this.enableTierClick = this.dataset.enableTierClick !== 'false';
          this.originalPriceHtml = this.priceElement?.innerHTML;
          this.onTierClick = this.onTierClick.bind(this);
          this.onQuantityChange = this.onQuantityChange.bind(this);
          this.onDismiss = this.onDismiss.bind(this);

          const dismissKey = `quantity-discounts-dismissed-${this.dataset.sectionId}`;
          if (sessionStorage.getItem(dismissKey) === 'true') {
            this.hidden = true;
            return;
          }

          this.dismissButton?.addEventListener('click', this.onDismiss);

          if (this.enableTierClick) {
            this.buttons.forEach((button) => button.addEventListener('click', this.onTierClick));
          }
          this.quantityInput?.addEventListener('input', this.onQuantityChange);
          this.quantityInput?.addEventListener('change', this.onQuantityChange);
          this.updateActiveTier();
        }

        disconnectedCallback() {
          this.buttons?.forEach((button) => button.removeEventListener('click', this.onTierClick));
          this.quantityInput?.removeEventListener('input', this.onQuantityChange);
          this.quantityInput?.removeEventListener('change', this.onQuantityChange);
          this.dismissButton?.removeEventListener('click', this.onDismiss);
        }

        onDismiss() {
          const dismissKey = `quantity-discounts-dismissed-${this.dataset.sectionId}`;
          sessionStorage.setItem(dismissKey, 'true');
          this.hidden = true;
        }

        onTierClick(event) {
          event.preventDefault();
          if (!this.enableTierClick) return;

          this.setQuantity(Number(event.currentTarget.dataset.quantity));
        }

        onQuantityChange() {
          this.updateActiveTier();
        }

        setQuantity(quantity) {
          if (!this.quantityInput || Number.isNaN(quantity)) return;

          this.quantityInput.value = this.normalizeQuantity(quantity);
          this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          this.updateActiveTier();
        }

        normalizeQuantity(quantity) {
          const input = this.quantityInput;
          const min = Number(input.getAttribute('min') || input.dataset.min || 1);
          const max = input.hasAttribute('max') ? Number(input.getAttribute('max')) : null;
          const step = Number(input.getAttribute('step') || 1);
          let nextQuantity = Math.max(quantity, min);

          if (step > 1) {
            const remainder = (nextQuantity - min) % step;
            if (remainder !== 0) nextQuantity += step - remainder;
          }

          if (max !== null) nextQuantity = Math.min(nextQuantity, max);

          return nextQuantity;
        }

        updateActiveTier() {
          const currentQuantity = Number(this.quantityInput?.value || 0);
          let activeButton = null;
          let nextButton = null;

          this.buttons.forEach((button) => {
            const tierQuantity = Number(button.dataset.quantity || 0);

            if (currentQuantity >= tierQuantity) {
              const activeQuantity = Number(activeButton?.dataset.quantity || 0);
              if (!activeButton || tierQuantity > activeQuantity) activeButton = button;
            }

            if (currentQuantity < tierQuantity) {
              const nextQuantity = Number(nextButton?.dataset.quantity || Infinity);
              if (!nextButton || tierQuantity < nextQuantity) nextButton = button;
            }
          });

          this.buttons.forEach((button) => {
            const isActive = button === activeButton;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          this.updateProductPrice(activeButton);
          this.updateLineItemProperties(activeButton);
          this.updateNextTierNotice(nextButton);
        }

        setBasePrice(basePriceCents, formatter) {
          const basePrice = Number(basePriceCents);
          if (!Number.isFinite(basePrice) || basePrice <= 0) return;

          this.dataset.basePrice = String(basePrice);
          const quantityTemplate = this.dataset.quantityLabelTemplate || '';

          this.buttons.forEach((button) => {
            const tierDiscount = Number(button.dataset.discount || 0);
            if (!Number.isFinite(tierDiscount) || tierDiscount <= 0) return;

            const discountedPriceCents = Math.round((basePrice * (100 - tierDiscount)) / 100);
            const formattedPrice = typeof formatter === 'function'
              ? formatter(discountedPriceCents)
              : String(discountedPriceCents);
            const customPrice = (discountedPriceCents / 100).toFixed(2);
            const tierQuantity = button.dataset.quantity || '';

            button.dataset.price = formattedPrice;
            button.dataset.customPrice = customPrice;

            const priceValue = button.querySelector('.quantity-discounts__tier-price-value');
            if (priceValue) priceValue.textContent = formattedPrice;

            const quantityLabel = button.querySelector('.quantity-discounts__tier-quantity');
            if (quantityLabel && quantityTemplate) {
              quantityLabel.textContent = quantityTemplate
                .replace(/\{\{\s*quantity\s*\}\}/g, tierQuantity)
                .replace(/\[quantity\]/g, tierQuantity);
            }
          });

          this.updateActiveTier();
        }

        updateProductPrice(activeButton) {
          if (!this.priceElement || !this.originalPriceHtml) return;

          const discount = Number(activeButton?.dataset.discount || 0);
          const price = activeButton?.dataset.price;

          if (!activeButton || discount <= 0 || !price) {
            this.priceElement.innerHTML = this.originalPriceHtml;
            return;
          }

          const priceWrapper = this.priceElement.querySelector('.f-price');
          const priceSelector = priceWrapper?.classList.contains('f-price--on-sale')
            ? '.f-price__sale .f-price-item--sale'
            : '.f-price__regular .f-price-item--regular';
          const priceTarget = this.priceElement.querySelector(priceSelector);

          if (priceTarget) priceTarget.textContent = price;
        }

        updateNextTierNotice(nextButton) {
          if (!this.nextTierElement) return;

          const template = this.nextTierElement.dataset.template || '';
          const quantity = nextButton?.dataset.quantity;
          const price = nextButton?.dataset.price;

          if (!nextButton || !template || !quantity || !price) {
            this.nextTierElement.textContent = '';
            this.nextTierElement.classList.add('hidden');
            return;
          }

          this.nextTierElement.textContent = template
            .replaceAll('[quantity]', quantity)
            .replaceAll('[price]', price);
          this.nextTierElement.classList.remove('hidden');
        }

        updateLineItemProperties(activeButton) {
          if (!this.customPriceInput && !this.qtyDiscountInput) return;

          const discount = Number(activeButton?.dataset.discount || 0);
          const customPrice = activeButton?.dataset.customPrice;

          if (!activeButton || discount <= 0 || !customPrice) {
            this.togglePropertyInput(this.customPriceInput, '');
            this.togglePropertyInput(this.qtyDiscountInput, '');
            return;
          }

          this.togglePropertyInput(this.customPriceInput, customPrice);
          this.togglePropertyInput(this.qtyDiscountInput, activeButton.dataset.discount);
        }

        togglePropertyInput(input, value) {
          if (!input) return;

          input.value = value || '';
          input.disabled = !value;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
